<template>
  <div>
    <el-table size="mini" :data="value" border class="w-100">
      <el-table-column align="center" prop="license_plate" label="车牌号">
      </el-table-column>
      <el-table-column align="center" prop="vehicle_type" label="车辆类型">
        <template slot-scope="scope">
          {{ scope.row.vehicle_type | formatVehicleType(vehicleTypes) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="over_length" label="车长">
        <template slot-scope="scope">
          {{ scope.row.over_length | formatOverLength(overLength) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="over_width" label="车宽">
        <template slot-scope="scope">
          {{ scope.row.over_width | formatOverWidth(overWidth) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="action" label="操作" v-if="!readonly">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="onEdit(scope.row, scope.$index)">编辑</el-button>
          <el-button size="mini" type="text" @click="onDelete(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button v-if="!readonly && (!value || (value && value.length < 4))" @click="onAddCar" size="small" type="text">
      添加
    </el-button>
    <el-dialog append-to-body title="添加车辆信息" :visible.sync="visible" width="500px">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="车牌号" prop="license_plate">
          <el-input :maxlength="8" v-model="form.license_plate" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="车辆类型" prop="vehicle_type">
          <el-select class="w-full" v-model="form.vehicle_type" placeholder="请选择车辆类型">
            <el-option v-for="item in vehicleTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车长" prop="over_length">
          <el-select class="w-full" v-model="form.over_length" placeholder="请选择车长">
            <el-option v-for="item in overLength" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车宽" prop="over_width">
          <el-select class="w-full" v-model="form.over_width" placeholder="请选择车宽">
            <el-option v-for="item in overWidth" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="onOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter';
import {cloneDeep, isNil} from 'lodash'
import {mapGetters} from "vuex";
import { VEHICLE_TYPE_LIST, getVehicleTypeLabel } from "@/assets/js/vehicleTypeEnum";

export default {
  props: ['value', 'readonly'],
  data() {
    return {
      visible: false,
      form: {
        license_plate: '',
        vehicle_type: undefined,
        over_length: undefined,
        over_width: undefined,
      },
      editCarIndex: "",
      vehicleTypes: VEHICLE_TYPE_LIST,
      overLength: [
        {name: "≤20米", id: 0},
        {name: ">20米", id: 1}
      ],
      overWidth: [
        // 统一将车宽阈值调整为 2.9 米，保证前台选项与导入导出规则一致。
        {name: "≤2.9米", id: 0},
        {name: ">2.9米", id: 1}
      ],
      rules: {
        license_plate: [
          {required: true, message: '请输入车牌号', trigger: 'change'},
          {message: '车牌号格式错误', trigger: 'change', pattern: /^.{7,8}$/}
        ],
        vehicle_type: [
          {required: true, message: '请选择车辆类型', trigger: 'change'}
        ],
        over_length: [
          {
            message: '请选择车长', trigger: 'change', validator: (rule, value, callback) => {
              if (this.baseInfo.com_code === 'DG' && isNil(value)) {
                callback(new Error('请选择车长'));
              } else {
                callback();
              }
            }
          }
        ],
        over_width: [
          {
            message: '请选择车宽', trigger: 'change', validator: (rule, value, callback) => {
              if (this.baseInfo.com_code === 'DG' && isNil(value)) {
                callback(new Error('请选择车宽'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    }
  },
  mixins: [emitter],
  methods: {
    // 打开新增车辆弹窗，供用户录入新的车辆信息。
    onAddCar() {
      this.visible = true;
    },
    // 回填当前行数据到表单，便于直接编辑车辆信息。
    onEdit(row, index) {
      this.editCarIndex = index;
      this.form = {
        license_plate: row.license_plate,
        vehicle_type: row.vehicle_type,
        over_length: row.over_length,
        over_width: row.over_width
      };
      this.visible = true;
    },
    // 校验并提交车辆信息。
    // 关键步骤：编辑场景按原索引覆盖，新增场景直接追加，保证父组件拿到最新列表。
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let arr = cloneDeep(this.value) || [];
          if (this.editCarIndex !== "") {
            arr.splice(this.editCarIndex, 1, this.form);
          } else {
            arr.push(this.form);
          }
          this.$emit('change', arr);
          this.dispatch('ElFormItem', 'el.form.change', [this.value]);

          this.onCancel();
        }
      });
    },
    // 关闭弹窗并重置表单状态，避免上一次录入内容污染下一次操作。
    onCancel() {
      this.visible = false;
      this.editCarIndex = "";
      this.form = {
        license_plate: '',
        vehicle_type: undefined
      }; // 重置表单
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 删除指定下标的车辆信息，并同步通知父级表单更新。
    onDelete(i) {
      const arr = this.value || [];
      this.$emit('change', arr.filter((item, index) => index !== i));
      this.dispatch('ElFormItem', 'el.form.change', [this.value]);

    }
  },
  filters: {
    // 将车辆类型枚举值转换为展示文案。
    formatVehicleType(value, vehicleTypes) {
      return getVehicleTypeLabel(value);
    },
    // 将车长枚举值转换为展示文案。
    formatOverLength(value, overLength) {
      if (!overLength || value == null) return '';
      const item = overLength.find(item => item.id === value);
      return item ? item.name : '';
    },
    // 将车宽枚举值转换为展示文案。
    formatOverWidth(value, overWidth) {
      if (!overWidth || value == null) return '';
      const item = overWidth.find(item => item.id === value);
      return item ? item.name : '';
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    ...mapGetters(["baseInfo"])
  }
}
</script>

<style lang="less" scoped></style>
